
import { SWRConfiguration, SWRResponse } from "swr";

import { GetEventSourceDataStatuses, QuerySourceDataStatusesResponse, SourceDataStatus } from "@/api/dtos";
import useGet from "@/hooks/api/useGet";
import { useMemo } from "react";

const getData = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => ({
    idMap: response?.data?.data?.reduce<Record<string, Record<number, SourceDataStatus>>>((a, b) => {
        if (!b?.studyEventOid || !b?.studyEventRepeat) {
            return a;
        }
        
        if (!a[b.studyEventOid]) {
            a[b.studyEventOid] = {};
        }

        a[b.studyEventOid][b.studyEventRepeat] = b;

        return a;
    },{})
});

export const useParticipantSourceDataEventStatuses = (participantId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!participantId) {
            return undefined;
        }

        return () => {
            return new GetEventSourceDataStatuses({ participantId });
        }
    }, [participantId]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useParticipantSourceDataEventStatuses;